import { determineNotificationPlugin, PushPluginType } from 'shared/engine-dynamic';
import { FirebaseJsChilduppNotification } from './firebasejs-childupp-notification';
import { PhonegapChilduppNotification } from './phonegap-childupp-notification';
import { FCMChilduppNotification } from "./fcm-childupp-notification";
import { NativeWebPushNotification } from './native-webpush-notification';
import { NoneChilduppNotification } from './none-childupp-notification';

/**
 * Build a notification service based on the plugin available
 * @return {IChilduppNotification}
 */
function buildEngineDynamicNotification() {
    const pluginType = determineNotificationPlugin();

    switch (pluginType) {
        case PushPluginType.PhonegapNotification:
            return new PhonegapChilduppNotification();
        case PushPluginType.FCMPlugin:
            return new FCMChilduppNotification();
        case PushPluginType.FirebaseJS:
            // Check if Firebase config is available
            if (window.CHILDUPP_PROPERTIES && window.CHILDUPP_PROPERTIES.FIREBASE_CONF) {
                return new FirebaseJsChilduppNotification();
            } else {
                // Fallback to native Web Push when Firebase config is missing
                console.log('[Notifications] Firebase config not available, using native Web Push');
                return new NativeWebPushNotification();
            }
        default:
            // Use native Web Push if VAPID key is available, otherwise none
            if (window.UPPLICATION_CONFIG && window.UPPLICATION_CONFIG.VAPID_PUBLIC_KEY) {
                console.log('[Notifications] Using native Web Push with VAPID');
                return new NativeWebPushNotification();
            }
            return new NoneChilduppNotification();
    }
}

/**
 * @type IChilduppNotification
 */
export default buildEngineDynamicNotification();



// WEBPACK FOOTER //
// ./src/shared/childupp-notifications/index.js